module.exports = __webpack_public_path__ + "img/lbl-02.72cc7e04.png";